import { render, staticRenderFns } from "./app-config-reward.vue?vue&type=template&id=07ccac2c&scoped=true"
import script from "./app-config-reward.vue?vue&type=script&lang=js"
export * from "./app-config-reward.vue?vue&type=script&lang=js"
import style0 from "./app-config-reward.vue?vue&type=style&index=0&id=07ccac2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ccac2c",
  null
  
)

export default component.exports